import { useCallback, useState } from "react";
import { SUPPLIER_DEFAULT_COUNTRY_GLOBAL } from "../../../../config/constants";
import {
  IngredientDataType,
  IngredientType
} from "../../../../config/enums/IngredientType.enum";
import { SupplierIngredientDetails } from "../supplierRegister.types";

interface UseSupplierFieldStateParams {
  currentDataType?: (type: string) => void;
  loadPackageData?: (value: boolean) => void;
  getDefaultCountry?: () => number | string | undefined;
}

export const useSupplierFieldState = ({
  currentDataType,
  loadPackageData,
  getDefaultCountry
}: UseSupplierFieldStateParams) => {
  const [newSupplier, setNewSupplier] = useState(false);
  const [ingredientType, setIngredientType] = useState<string>(IngredientType.RAW);
  const [defaultType, setDefaultType] = useState<string>("kg");
  const [country, setCountry] = useState<number>(1);
  const [supplierCountry, setSupplierCountry] = useState<number>(SUPPLIER_DEFAULT_COUNTRY_GLOBAL);
  const [isSupplierAsUser, setIsSupplierAsUser] = useState<boolean>(false);
  const [produceType, setProduceType] = useState<string>("");
  const [farmingType, setFarmingType] = useState<string>("Unknown");
  const [fieldType, setFieldType] = useState<string>("Unknown");
  const [specifyIngredientValue, setSpecifyIngredientValue] = useState<string>("");
  const [isSupplierExist, setIsSupplierExist] = useState<boolean>(false);

  const resetFields = useCallback(() => {
    setIngredientType(IngredientType.RAW);
    setDefaultType("kg");
    setCountry(Number(getDefaultCountry?.()) || SUPPLIER_DEFAULT_COUNTRY_GLOBAL);
    currentDataType?.(IngredientDataType.SUPPLIER);
    loadPackageData?.(false);
    setProduceType("");
    setFarmingType("Unknown");
    setFieldType("Unknown");
    setSpecifyIngredientValue("");
  }, [currentDataType, getDefaultCountry, loadPackageData]);

  const applyIngredientDetails = useCallback((details?: SupplierIngredientDetails) => {
    if (!details) return;

    setDefaultType(details.unit_type || "kg");
    setProduceType(details.produceType || "");
    setFarmingType(details.farmingType || "Unknown");
    setFieldType(details.fieldType || "Unknown");
    setSpecifyIngredientValue(details.specifyIngredient || "");
    setIngredientType(details.ingredient_type || IngredientType.RAW);
    setCountry(details.countryOrigin || SUPPLIER_DEFAULT_COUNTRY_GLOBAL);
  }, []);

  return {
    newSupplier,
    setNewSupplier,
    ingredientType,
    setIngredientType,
    defaultType,
    setDefaultType,
    country,
    setCountry,
    supplierCountry,
    setSupplierCountry,
    isSupplierAsUser,
    setIsSupplierAsUser,
    produceType,
    setProduceType,
    farmingType,
    setFarmingType,
    fieldType,
    setFieldType,
    specifyIngredientValue,
    setSpecifyIngredientValue,
    isSupplierExist,
    setIsSupplierExist,
    resetFields,
    applyIngredientDetails
  };
};
